import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router';

import { FallbackComponent } from '@/components/common/FallbackComponent';
import { NavigationProvider } from '@/providers';

import { IAppProvider } from './AppProvider.interfaces';

const AppProvider = ({ children }: IAppProvider) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <React.StrictMode>
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <NavigationProvider>
              <Toaster />
              {children}
            </NavigationProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

export { AppProvider };
